import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dfe9938"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weather" }
const _hoisted_2 = {
  autoplay: "",
  class: "audio",
  id: "audio-player"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "weather-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "weather-text-small" }, " Welcome To ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "weather-text-large" }, " cosborn Weather ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "weather-text-xs" }, " cosborn Weather Service Broadcast ", -1))
const _hoisted_8 = { class: "weather-text-regular" }
const _hoisted_9 = { class: "current-weather" }
const _hoisted_10 = {
  key: 1,
  class: "weather-text-small"
}

import { onBeforeMount, onMounted, ref, watch } from 'vue'
import songs from '@/assets/weather/songs.json'
import { getWeather, getLocationInfo } from '@/api/weather'
import codes from '@/assets/weather/codes'


export default /*#__PURE__*/_defineComponent({
  __name: 'Weather',
  setup(__props) {

const weatherData = ref<any>()
const locationData = ref<any>()

const shuffle = (array: Array<string>) => {
  let currentIndex = array.length,  randomIndex;
  while (currentIndex > 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
}

onBeforeMount(() => {
  shuffle(songs.titles)
})

onMounted(() => {
  const audioPlayer = document.getElementById('audio-player') as HTMLAudioElement
  const audioIndex = ref(1)

  const playNext = () => {
    audioPlayer!.src = require(`@/assets/weather/${songs.titles[audioIndex.value]}.mp3`)
    audioPlayer!.play();
    audioIndex.value++
  }

  audioPlayer!.addEventListener('ended', playNext)
})

const frame = ref(0)
const incrementWeatherFrame = () => { frame.value++ }
setTimeout(incrementWeatherFrame, 3000)

const verifyAndGetWeather = (latitude: string, longitude: string) => {
  getWeather(latitude, longitude).then(weatherResponse => {
    weatherData.value = weatherResponse.data
    getLocationInfo(latitude, longitude, process.env.VUE_APP_GEOCODE_API_KEY).then(locationResponse => {
      locationData.value = locationResponse.data
    })
  })
}

navigator.geolocation.getCurrentPosition((position) => {
  verifyAndGetWeather(position.coords.latitude.toString(), position.coords.longitude.toString());
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("audio", _hoisted_2, [
      _createElementVNode("source", {
        src: require(`@/assets/weather/${_unref(songs).titles[0]}.mp3`)
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (frame.value === 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_5,
            _hoisted_6
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (weatherData.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    (locationData.value.address.town && locationData.value.address.country==='United States')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(locationData.value.address.town) + ", " + _toDisplayString((locationData.value.address['ISO3166-2-lvl4']).slice(-2)), 1)
                        ], 64))
                      : (locationData.value.address.city && locationData.value.address.country==='United States')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(locationData.value.address.city) + ", " + _toDisplayString((locationData.value.address['ISO3166-2-lvl4']).slice(-2)), 1)
                          ], 64))
                        : (locationData.value.address.town && locationData.value.address.state)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode(_toDisplayString(locationData.value.address.town) + ", " + _toDisplayString(locationData.value.address.state), 1)
                            ], 64))
                          : (locationData.value.address.city && locationData.value.address.state)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createTextVNode(_toDisplayString(locationData.value.address.city) + ", " + _toDisplayString(locationData.value.address.state), 1)
                              ], 64))
                            : (locationData.value.address.country)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  _createTextVNode(_toDisplayString(locationData.value.address.country), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                  _createTextVNode(" wherever the hell you are ")
                                ], 64)),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", null, _toDisplayString(weatherData.value.current_weather.temperature + '°F'), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(codes)[weatherData.value.current_weather.weathercode]), 1)
                    ])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_10))
          ], 64))
    ])
  ]))
}
}

})